import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=11d564f5&scoped=true&"
import script from "./EditCategory.vue?vue&type=script&lang=js&"
export * from "./EditCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditCategory.vue?vue&type=style&index=0&id=11d564f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d564f5",
  null
  
)

export default component.exports